import request from '@/utils/request';

/**
 * @description 查询店铺映射列表
 * @param keyword
 * @param pageNum
 * @param pageSize
 */
function queryStoreMappingList({ keyword, pageNum, pageSize } = {}) {
  return request({
    url: 'shop/pageQueryShopList',
    method: 'get',
    params: {
      keyword,
      pageNum,
      pageSize
    },
    isKdtId: true
  });
}

/**
 * @description 查询有赞店铺列表
 * @param keyword
 */
function queryYzStoreList({ keyword = '' } = {}) {
  return request({
    url: 'shop/queryShopBriefInfo',
    method: 'get',
    params: { keyword }
  });
}

/**
 * @description 查询美团店铺列表
 */
function queryMtStoreList() {
  return request({
    url: 'shop/queryMtOpPoiInfo',
  });
}

/**
 * @description 店铺映射绑定
 * @param kdtId
 * @param opPoiId
 * @param opPoiName
 * @returns {*}
 */
function shopMappingBind({ kdtId, opPoiId, opPoiName } = {}) {
  return request({
    url: 'shop/bindShop',
    method: 'post',
    data: {
      kdtId,
      opPoiId,
      opPoiName
    },
    isKdtId: true
  })
}

/**
 * @description 查询店铺营业设置列表
 */
function queryStoreBusinessSettingsList({ keyword, pageNum, pageSize } = {}) {
  return request({
    url: 'shop/business/pageQueryBusinessSettings',
    method: 'get',
    params: {
      keyword,
      pageNum,
      pageSize
    },
    isKdtId: true
  });
}

/**
 * @description 保存门店营业设置
 */
function saveStoreBusinessSettings({ kdtId, bindRule, businessStartTime, businessEndTime, separateTime } = {}) {
  return request({
    url: 'shop/business/saveSettings',
    method: 'post',
    data: {
      kdtId,
      bindRule,
      businessStartTime,
      businessEndTime,
      separateTime
    },
    isKdtId: true
  });
}

/**
 * @description 查询店铺预约数据
 */
function queryStoreReservationData({ kdtId, orderNo, mtOrderId, reservationNo, mobile, reservationStatus, finishStartTime, finishEndTime, pageNum, pageSize } = {}) {
  return request({
    url: 'order/pageQueryOrderList',
    method: 'get',
    params: {
      kdtId,
      orderNo,
      mtOrderId,
      reservationNo,
      mobile,
      reservationStatus,
      finishStartTime,
      finishEndTime,
      pageNum,
      pageSize
    },
    isKdtId: true
  });
}

/**
 * @description 导出店铺预约数据
 */
function exportStoreReservationData({ kdtId, orderNo, mtOrderId, reservationNo, mobile, reservationStatus, finishStartTime, finishEndTime, pageNum, pageSize } = {}) {
  return request({
    url: 'order/exportOrderInfo',
    method: 'get',
    params: {
      orderNo,
      mtOrderId,
      reservationNo,
      mobile,
      reservationStatus,
      finishStartTime,
      finishEndTime,
      pageNum,
      pageSize
    },
    kdtId,
    isKdtId: true,
    responseType: 'blob'
  });
}

/**
 * @description 查询美团店铺授权绑定状态
 */
function queryStoreAuthorizationStatus() {
  return request({
    url: 'shop/queryTokenValidityPeriod',
    method: 'get',
  });
}

/**
 * @description 查询门店时间段库存配置列表
 */
function queryStoreInventoryList({ keyword, pageNum, pageSize } = {}) {
  return request({
    url: 'nonBeta/store/pageQueryAllNonBetaMtShop',
    method: 'get',
    params: {
      keyword,
      pageNum,
      pageSize,
    },
    isKdtId: true
  });
}

/**
 * @description 查询门店时间段库存配置详情
 */
function queryStoreInventoryItemDetail({ kdtId, occupyDate } = {}) {
  return request({
    url: 'nonBeta/store/queryOccupiedStockSettings',
    method: 'get',
    params: {
      occupyDate
    },
    kdtId,
    isKdtId: true
  });
}

/**
 * @description 更新门店时间段库存配置
 */
function updateStoreInventoryItem({ kdtId, occupyDate, occupyBegin, occupyEnd, occupyStock, occupyBlock } = {}) {
  return request({
    url: 'nonBeta/store/saveOccupiedStockSettings',
    method: 'post',
    data: {
      occupyDate,
      occupyBegin,
      occupyEnd,
      occupyStock,
      occupyBlock,
    },
    kdtId,
    isKdtId: true
  });
}

export default {
  queryStoreMappingList,
  queryYzStoreList,
  queryMtStoreList,
  shopMappingBind,
  queryStoreBusinessSettingsList,
  saveStoreBusinessSettings,
  queryStoreReservationData,
  exportStoreReservationData,
  queryStoreAuthorizationStatus,
  queryStoreInventoryList,
  queryStoreInventoryItemDetail,
  updateStoreInventoryItem,
};
